import styled from "styled-components"
import { BREAKPOINTS } from "../../constants"

export const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
  gap: 1.6rem;
  @media (min-width: ${BREAKPOINTS["small-viewport"]}) {
    grid-template-columns: ${props =>
      props.Count ? `repeat(${props.Count}, 1fr)` : `repeat(2, 1fr)`};
    div:last-child:nth-child(odd) {
      /* Last child AND odd */
      /* grid-column: ${props => (props.Count ? `` : `1 / 3`)}; */
    }
  }
`

const Card = styled.div`
  will-change: transform;
  ::before {
    content: "";
    display: ${props => (props.Icon ? "inline-block" : "none")};
    mask: url(${props => props.Icon || ""}) no-repeat center;
    mask-size: contain;
    height: 4rem;
    width: 4rem;
    max-height: min(8rem, calc(100vw / 4));
    /* max-width: min(8rem, calc(100vw / 4));; */
    background-color: var(--color-theme-accent);
    margin-bottom: 1rem;
  }
  transition: transform 240ms ease-in-out;
  @keyframes sparkle {
    from {
      filter: hue-rotate(0deg);
    }
    to {
      filter: hue-rotate(-360deg);
    }
  }
  @keyframes change-hue {
    from {
      border-color: var(--color-theme-accent);
    }
    to {
      border-color: var(--color-theme-secondary-accent);
    }
  }
  :hover {
    filter: drop-shadow(8px 8px 8px rgb(0 0 0 / 12%));
    transform: translate(-2%, -2%);
    transition: transform 240ms ease-in-out;
  }
  display: flex;
  flex-direction: column;
  background: var(--color-background-48-dp-elevation);
  padding: 2rem 1rem;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
  > h5 {
    margin-bottom: 1rem;
  }
  > ul {
    margin-top: 0.8rem;
  }
  &.dont-emphasize {
    background-color: inherit;
    /* box-shadow: none; */
    border-width: 4px 1px 1px 1px;
    border-style: solid;
    box-shadow: 0px 0px 8px 2px rgb(0 0 0 / 12.5%);
    /* border-top-style: solid;
    border-left-style: solid; */
    border-color: var(--color-theme-accent);
    border-radius: 1rem;
    :hover {
      animation: ${props =>
        props.sparkleOff ? "change-hue 8s infinite alternate linear" : "sparkle 8s infinite linear"};
    }
  }
`

export default Card
